import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ReactComponent as WifiIcon } from "../../assets/InsuiteAmenities/WifiHigh.svg";
import { ReactComponent as Bed } from "../../assets/InsuiteAmenities/Bed.svg";
import { ReactComponent as Bathtub } from "../../assets/InsuiteAmenities/Bathtub.svg";
import { ReactComponent as Coat } from "../../assets/InsuiteAmenities/Coat.svg";
import { ReactComponent as DeviceTablet } from "../../assets/InsuiteAmenities/DeviceTablet.svg";
import { ReactComponent as FirstAidKit } from "../../assets/InsuiteAmenities/FirstAidKit.svg";
import { ReactComponent as HairDryer } from "../../assets/InsuiteAmenities/HairDryer.svg";
import { ReactComponent as LawnChair } from "../../assets/InsuiteAmenities/LawnChair.svg";
import { ReactComponent as MonitorPlay } from "../../assets/InsuiteAmenities/MonitorPlay.svg";
import { ReactComponent as Shower } from "../../assets/InsuiteAmenities/Shower.svg";
import { ReactComponent as Spade } from "../../assets/InsuiteAmenities/Spade.svg";
import { ReactComponent as SwimmingPool } from "../../assets/InsuiteAmenities/SwimmingPool.svg";
import { ReactComponent as Swing } from "../../assets/InsuiteAmenities/Swing.svg";
import { ReactComponent as YogaMat } from "../../assets/InsuiteAmenities/YogaMat.svg";
import { ReactComponent as Film } from "../../assets/CommonAmenitiesImg/FilmSlate.svg";
import { ReactComponent as Karoake } from "../../assets/CommonAmenitiesImg/MicrophoneStage.svg";
import { ReactComponent as Fire } from "../../assets/CommonAmenitiesImg/Campfire.svg";
import { ReactComponent as YogaPerson } from "../../assets/CommonAmenitiesImg/Person.svg";
import { ReactComponent as Villa } from "../../assets/CommonAmenitiesImg/Farm.svg";
import { ReactComponent as CallBell } from "../../assets/CommonAmenitiesImg/CallBell.svg";
import { ReactComponent as LetterP } from "../../assets/CommonAmenitiesImg/LetterCircle.svg";
import { ReactComponent as SecurityCamera } from "../../assets/CommonAmenitiesImg/SecurityCamera.svg";
import { ReactComponent as Racquet } from "../../assets/CommonAmenitiesImg/Racquet.svg";
import { AccordionSection } from "../tariff/TariffPage";

const Amenities = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const styles = {
    container: {
      maxWidth: "100%",
      width: isMobile ? "90%" : "80%",
      padding: "20px",
    },
    mainheading: {
      fontFamily: "ZapfHumnst BT",
      fontSize: { xs: "16px", sm: "24px" },
      lineHeight: { xs: "19.8px", sm: "39.71px" },
      letterSpacing: "0.05em",
      textAlign: "left",
      color: "#181818",
      margin: 0,
      position: "relative",
    },
    heading: {
      fontFamily: "Sora",
      fontSize: { xs: "12px", sm: "16px" },
      fontWeight: 300,
      lineHeight: { xs: "26px", sm: "26px" },
      letterSpacing: "0.01em",
      textAlign: "left",
      textUnderlinePosition: "from-font",
      textDecorationSkipInk: "none",
      display: "flex",
      alignItems: "center",
      color: "#442A0B",
    },
    underline: {
      position: "absolute",
      bottom: -5,
      left: 0,
      width: "100%",
      height: "2px",
      backgroundColor: "#E4CAAE",
    },
    icon: {
      width: "24px",
      height: "24px",
      marginRight: "10px",
    },
    gridContainer: {
      display: "grid",
      gridTemplateColumns: {
        xs: "1fr",
        sm: "1fr",
        md: "1.5fr 1fr",
      },
      marginTop: "20px",
      marginBottom: "5%",
    },
    section: {
      padding: { xs: "5px", sm: "10px", md: "15px" },
      display: "flex",
      height: "auto",
      position: "relative",
      marginLeft: { sm: "-10px", md: "-10px", lg: "-18px" },
    },
  };

  const suiteDetails = [
    { icon: <SwimmingPool style={styles.icon} />, heading: "Private Swimming Pool" },
    { icon: <Bathtub style={styles.icon} />, heading: "Luxurious Soaking Tub" },
    { icon: <WifiIcon style={styles.icon} />, heading: "High-Speed Wi-Fi Access" },
    { icon: <Spade style={styles.icon} />, heading: "Curated Board Game Collection" },
    { icon: <Swing style={styles.icon} />, heading: "Elegant Garden Swing" },
    { icon: <MonitorPlay style={styles.icon} />, heading: "Netflix & Chill Experience" },
    { icon: <Shower style={styles.icon} />, heading: "opulent En-suite with Rain Shower" },
    { icon: <Bed style={styles.icon} />, heading: "Super King-Size Bed Retreat" },
    { icon: <FirstAidKit style={styles.icon} />, heading: "Toiletries and First Aid Kit" },
    { icon: <LawnChair style={styles.icon} />, heading: "Sun Deck Area" },
    { icon: <DeviceTablet style={styles.icon} />, heading: "Mini Fridge" },
    { icon: <HairDryer style={styles.icon} />, heading: "Hair Dryer" },
    { icon: <Coat style={styles.icon} />, heading: "Plush Bathrobe" },
    { icon: <YogaMat style={styles.icon} />, heading: "Comfort Yoga Mat" },
  ];

  const commonAmenities = [
    { icon: <Film style={{ width: "20px", height: "20px", marginRight: "10px" }} />, text: "Under the Star Movie" },
    { icon: <Karoake style={{ width: "20px", height: "20px", marginRight: "10px" }} />, text: "Karaoke Entertainment" },
    { icon: <Fire style={{ width: "20px", height: "20px", marginRight: "10px" }} />, text: "Cozy Bonfire Nights" },
    { icon: <YogaPerson style={{ width: "20px", height: "20px", marginRight: "10px" }} />, text: "Yoga & Meditation Retreat" },
    { icon: <Villa style={{ width: "20px", height: "20px", marginRight: "10px" }} />, text: "Authentic Farm Experience" },
    { icon: <CallBell style={{ width: "20px", height: "20px", marginRight: "10px" }} />, text: "Personalised Concierge & Housekeeping" },
    { icon: <LetterP style={{ width: "20px", height: "20px", marginRight: "10px" }} />, text: "24/7 Free Parking" },
    { icon: <SecurityCamera style={{ width: "20px", height: "20px", marginRight: "10px" }} />, text: "CCTV Surveillance" },
    { icon: <Racquet style={{ width: "20px", height: "20px", marginRight: "10px" }} />, text: "Outdoor Play Area for kids" },
  ];

  const accordionContent = [
    {
      title: "COMMON AMENITIES",
      points: commonAmenities, // Pass the updated list
    },
    {
      title: "SUITE RULES",
      points: [
        "⁠No shoes indoor",
        "No diving in the pool",
        "No pets allowed.",
        "No unregistered guest.",
        "Quiet hours from 10pm - 7am",
        "No smoking of any kind inside the suite",
        "No loud parties (respect our neighbours)",
        "No open flames or candles inside the suite",
        "⁠Guest is responsible for any damages to the property, decor, or furniture.",
      ],
    },
    {
      title: "CANCELLATION POLICY",
      points: [
        "Free Cancellation within 24 hours",
        "50% refund within 3 days",
        "No refund after 3 days",
        "Booking Fee is Non-Refundable",
        "Early Cancellation is Encouraged",
        "Flexible Rescheduling Option",
        "Refund to Original Payment Method",
        "Notify 24 Hours in Advance",
      ],
    },
  ];

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.mainheading}>
        IN-SUITE AMENITIES
        <Box sx={styles.underline} />
      </Typography>
      <Box sx={styles.gridContainer}>
        {suiteDetails.map((detail, index) => (
          <Box key={index} sx={styles.section}>
            {detail.icon}
            <Typography sx={styles.heading}>{detail.heading}</Typography>
          </Box>
        ))}
      </Box>

      <AccordionSection accordionContent={accordionContent} />
    </Box>
  );
};

export default Amenities;
